import { render } from "./DataProtection.vue?vue&type=template&id=874092da&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"

import "./DataProtection.vue?vue&type=style&index=0&id=874092da&scoped=true&lang=css"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874092da"]])

export default __exports__